import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskPanelComponent } from './task-panel/task-panel.component';
import {RouterModule, Routes} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ResizableModule } from 'angular-resizable-element';
import { NzResizableModule } from 'ng-zorro-antd/resizable';
import { InjectableRxStompConfig, RxStompService, rxStompServiceFactory } from '@stomp/ng2-stompjs';
import { myRxStompConfig } from './utils/stomp.config';
import { QuillModule } from 'ngx-quill';
import { NgFondaModule } from 'ng-fonda';
import {BpmnViewModule} from 'ngx-task-bpmn-view';
import { NgxPermissionsModule } from 'ngx-permissions';
import { IntegrationComponent } from './widget/integration/integration.component';
import { ConversationComponent } from './widget/conversation/conversation.component'; // 表格视图对话组件
import { FilterComponent } from './widget/filter/filter.component'; // 筛选组件
import { TableComponent } from './views/table/table.component'; // 表格视图
import { CalendarComponent } from './views/calendar/calendar.component';  // 日历视图
import { MultiplePersonComponent } from './components/multiple-person/multiple-person.component';  // 成员组件
import { StatusComponent } from './components/status/status.component';  // 状态组件
import { DropdownComponent } from './components/dropdown/dropdown.component'; // 下拉组件
import { ArchiveComponent } from './views/archive/archive.component'; // 归档组件
import { LayoutComponent } from './layout/layout.component'; // 布局组件
import { PulseCardComponent } from './widget/pulse-card/pulse-card.component'; // 弹窗增加任务
import { AutomationComponent } from './widget/automation/automation.component'; // 自动化列表
import { AbstractPartComponent } from './widget/automation/config/abstract-part-component'; // 抽象组件
import { CommonStatusComponent } from './widget/automation/parts/common-status/common-status.component'; // 自动化 - 通用状态模板
import { CommonDateComponent } from './widget/automation/parts/common-date/common-date.component'; // 自动化 - 通用日期模板
import { CommonColumnComponent } from './widget/automation/parts/common-column/common-column.component';  // 自动化 - 通用列模板
import { CustomSpecialConditionComponent } from './widget/automation/parts/custom-special-condition/custom-special-condition.component';  // 自动化 - 特殊定时模板
import { PulseIntegrationComponent } from './widget/pulse-integration/pulse-integration.component';  // 自动化 - 集成新增任务
import { SchedulerComponent } from './widget/scheduler/scheduler.component';  // 自动化 - 通用定时组件
import { CommonSchedulerComponent } from './widget/automation/parts/common-scheduler/common-scheduler.component'; // 自动化 - 通用定时模板
import { LongTimeAgoPipe } from './utils/pipes/long-time-ago.pipe'; // 管道
import { TransforStringJsonPipe } from './utils/pipes/transfor-string-json.pipe'; // 管道
import { WhenComponent } from './widget/when/when.component';  // WHEN组件
import { BoardMemberComponent } from './widget/board-member/board-member.component';
import { TimerComponent } from './widget/timer/timer.component';
import { CommonTimerComponent } from './widget/automation/parts/common-timer/common-timer.component';
import { CommonSendEmailComponent } from './widget/automation/parts/common-send-email/common-send-email.component';
import { CommonTimerEmailComponent } from './widget/automation/parts/common-timer-email/common-timer-email.component';
import { TDayComponent } from './widget/t-day/t-day.component';
import { ConditionComponent } from './widget/condition/condition.component';
import { CommonStatusArchiveComponent } from './widget/automation/parts/common-status-archive/common-status-archive.component';
import { DateTimeComponent } from './widget/date-time/date-time.component';
import { SelectComponent } from './components/select/select.component';
import { NotificationComponent } from './widget/notification/notification.component';
import { CommonStatusTimerEmailComponent } from './widget/automation/parts/common-status-timer-email/common-status-timer-email.component';
import { InfoboxComponent } from './widget/infobox/infobox.component'; // 面板用户组件
import { CommonTimerNotificationComponent } from './widget/automation/parts/common-timer-notification/common-timer-notification.component';
import { ArchivedBoardComponent } from './archived-board/archived-board.component';
import { UserComponent } from './widget/user/user.component';
import { PulseCreatedSendNotificationComponent } from './widget/automation/parts/pulse-created-send-notification/pulse-created-send-notification.component';
import { FileComponent } from './widget/file/file.component';
import { LinkComponent } from './widget/link/link.component';
import { SearchPipePipe } from './widget/automation/pipe/search-pipe.pipe';
import { CommonTextChangeComponent } from './widget/automation/parts/common-text-change/common-text-change.component';
import { CommonProductChangeUpdateComponent } from './widget/automation/parts/common-product-change-update/common-product-change-update.component';
import { CommonStatusNotifyComponent } from './widget/automation/parts/common-status-notify/common-status-notify.component';
import { CommonStatusChangeUserComponent } from './widget/automation/parts/common-status-change-user/common-status-change-user.component';
import { NewCalendarComponent } from './views/new-calendar/new-calendar.component';
import { TimeIntervalComponent } from './widget/time-interval/time-interval.component';
import { MemberComponent } from './widget/member/member.component';
import { RelationDataComponent } from './widget/relation-data/relation-data.component';
import { StatusGroupMovingComponent } from './widget/automation/parts/status-group-moving/status-group-moving.component';
import { StatusConditionCreateComponent } from './widget/automation/parts/status-condition-create/status-condition-create.component';
import { StatusGroupMovingNotifyComponent } from './widget/automation/parts/status-group-moving-notify/status-group-moving-notify.component';
import { VoteComponent } from './widget/vote/vote.component';
import { DateSliderComponent } from './widget/date-slider/date-slider.component';
import { LastUpdatedComponent } from './widget/last-updated/last-updated.component';

// zorro组件
import {NzGridModule} from 'ng-zorro-antd/grid';
import {NzDividerModule} from 'ng-zorro-antd/divider';
import {NzIconModule, NzIconService} from 'ng-zorro-antd/icon';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzInputNumberModule} from 'ng-zorro-antd/input-number';
import {NzAutocompleteModule} from 'ng-zorro-antd/auto-complete';
import {NzCascaderModule} from 'ng-zorro-antd/cascader';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {NzDatePickerModule} from 'ng-zorro-antd/date-picker';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzRadioModule} from 'ng-zorro-antd/radio';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {NzSliderModule} from 'ng-zorro-antd/slider';
import {NzSwitchModule} from 'ng-zorro-antd/switch';
import {NzTimePickerModule} from 'ng-zorro-antd/time-picker';
import {NzTransferModule} from 'ng-zorro-antd/transfer';
import {NzTreeSelectModule} from 'ng-zorro-antd/tree-select';
import {NzUploadModule} from 'ng-zorro-antd/upload';
import {NzAvatarModule} from 'ng-zorro-antd/avatar';
import {NzBadgeModule} from 'ng-zorro-antd/badge';
import {NzCalendarModule} from 'ng-zorro-antd/calendar';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzPopoverModule} from 'ng-zorro-antd/popover';
import {NzStatisticModule} from 'ng-zorro-antd/statistic';
import {NzTableModule} from 'ng-zorro-antd/table';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {NzTagModule} from 'ng-zorro-antd/tag';
import {NzToolTipModule} from 'ng-zorro-antd/tooltip';
import {NzTreeModule} from 'ng-zorro-antd/tree';
import {NzAlertModule} from 'ng-zorro-antd/alert';
import {NzDrawerModule} from 'ng-zorro-antd/drawer';
import {NzMessageModule} from 'ng-zorro-antd/message';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {NzPopconfirmModule} from 'ng-zorro-antd/popconfirm';
import {NzProgressModule} from 'ng-zorro-antd/progress';
import {NzSpinModule} from 'ng-zorro-antd/spin';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzAffixModule} from 'ng-zorro-antd/affix';
import {NzDropDownModule} from 'ng-zorro-antd/dropdown';
import {NzStepsModule} from 'ng-zorro-antd/steps';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { StatusTimerArchiveComponent } from './widget/automation/parts/status-timer-archive/status-timer-archive.component';
import { WorkRelationComponent } from './widget/automation/parts/work-relation/work-relation.component';
import { CommonWorkflowCreateTaskComponent } from './widget/automation/parts/common-workflow-create-task/common-workflow-create-task.component';
import { CommonWorkflowUpdateTaskComponent } from './widget/automation/parts/common-workflow-update-task/common-workflow-update-task.component';
import { CommonWorkflowDeleteTaskComponent } from './widget/automation/parts/common-workflow-delete-task/common-workflow-delete-task.component';
import { CommonAuditCreateTaskComponent } from './widget/automation/parts/common-audit-create-task/common-audit-create-task.component';
import { CommonAuditDeleteTaskComponent } from './widget/automation/parts/common-audit-delete-task/common-audit-delete-task.component';
import { CommonAuditUpdateTaskComponent } from './widget/automation/parts/common-audit-update-task/common-audit-update-task.component';
import { NewTableComponent } from './views/new-table/new-table.component';
import { TablePulseAbstractComponent } from './dynamic-components/table-view/table-pulse-abstract/table-pulse-abstract.component';
import { TableViewAbstractComponent } from './dynamic-components/table-view/table-view-abstract/table-view-abstract.component';
import { TableColumnNameComponent } from './dynamic-components/table-view/columns/table-column-name/table-column-name.component';
import { TableColumnTextComponent } from './dynamic-components/table-view/columns/table-column-text/table-column-text.component';
import { TableColumnDateComponent } from './dynamic-components/table-view/columns/table-column-date/table-column-date.component';
import { TableColumnStatusComponent } from './dynamic-components/table-view/columns/table-column-status/table-column-status.component';
import { TableColumnProgressComponent } from './dynamic-components/table-view/columns/table-column-progress/table-column-progress.component';
import { TablePulseNameComponent } from './dynamic-components/table-view/pulses/table-pulse-name/table-pulse-name.component';
import { TablePulseDateComponent } from './dynamic-components/table-view/pulses/table-pulse-date/table-pulse-date.component';
import { TablePulseProgressComponent } from './dynamic-components/table-view/pulses/table-pulse-progress/table-pulse-progress.component';
import { TablePulseStatusComponent } from './dynamic-components/table-view/pulses/table-pulse-status/table-pulse-status.component';
import { TablePulseTextComponent } from './dynamic-components/table-view/pulses/table-pulse-text/table-pulse-text.component';
import { TablePulseMultiplePersonComponent } from './dynamic-components/table-view/pulses/table-pulse-multiple-person/table-pulse-multiple-person.component';
import { TableColumnMultiplePersonComponent } from './dynamic-components/table-view/columns/table-column-multiple-person/table-column-multiple-person.component';
import { TableColumnSelectComponent } from './dynamic-components/table-view/columns/table-column-select/table-column-select.component';
import { TablePulseSelectComponent } from './dynamic-components/table-view/pulses/table-pulse-select/table-pulse-select.component';
import { TableColumnDateTimeComponent } from './dynamic-components/table-view/columns/table-column-date-time/table-column-date-time.component';
import { TableColumnTimeIntervalComponent } from './dynamic-components/table-view/columns/table-column-time-interval/table-column-time-interval.component';
// import { TablePulseDataTimeComponent } from './dynamic-components/table-view/pulses/table-pulse-data-time/table-pulse-data-time.component';
import { TablePulseTimeIntervalComponent } from './dynamic-components/table-view/pulses/table-pulse-time-interval/table-pulse-time-interval.component';
import { TableColumnButtonComponent } from './dynamic-components/table-view/columns/table-column-button/table-column-button.component';
import { TableColumnDropdownComponent } from './dynamic-components/table-view/columns/table-column-dropdown/table-column-dropdown.component';
import { TablePulseButtonComponent } from './dynamic-components/table-view/pulses/table-pulse-button/table-pulse-button.component';
import { TablePulseDropdownComponent } from './dynamic-components/table-view/pulses/table-pulse-dropdown/table-pulse-dropdown.component';
import { TableColumnCreateTimeComponent } from './dynamic-components/table-view/columns/table-column-create-time/table-column-create-time.component';
import { TablePulseCreateTimeComponent } from './dynamic-components/table-view/pulses/table-pulse-create-time/table-pulse-create-time.component';
import { TreeTableComponent } from './views/tree-table/tree-table.component';
import { MultipleLevelPersonComponent } from './components/multiple-level-person/multiple-level-person.component';
import { TaskStatusComponent } from './components/task-status/task-status.component';
import { TaskHandleComponent } from './components/task-handle/task-handle.component';
import { TaskProgressComponent } from './components/task-progress/task-progress.component';
import { HandlerComponent } from './components/handler/handler.component';
import { TaskButtonComponent } from './components/task-button/task-button.component';
import { CommonTaskStatusArchiveComponent } from './widget/automation/parts/common-task-status-archive/common-task-status-archive.component';
import { CommonSupervisoryUpdateTaskComponent } from './widget/automation/parts/common-supervisory-update-task/common-supervisory-update-task.component';
import { CommonLogTaskArchiveComponent } from './widget/automation/parts/common-log-task-archive/common-log-task-archive.component';
import { CheckListComponent } from './components/check-list/check-list.component';
import { RatioSuperisoryComponent } from './components/ratio-superisory/ratio-superisory.component';
import { WarnedComponent } from './components/warned/warned.component';
import { SupervisorySchedulerComponent } from './components/supervisory-scheduler/supervisory-scheduler.component';
import { TaskFilterComponent } from './components/task-filter/task-filter.component';
import { TaskManagementComponent } from './components/task-management/task-management.component';
import { SetSchedulerComponent } from './components/task-management/set-scheduler/set-scheduler.component';
import { IntegrateSupervisoryCreatComponent } from './widget/automation/parts/integrate-supervisory-creat/integrate-supervisory-creat.component';
import { IntegrateSupervisoryTaskRuleCreatComponent } from './widget/automation/parts/integrate-supervisory-task-rule-creat/integrate-supervisory-task-rule-creat.component';
import { CreateTaskByIndicatorAbnormalStatusComponent } from './widget/automation/parts/create-task-by-indicator-abnormal-status/create-task-by-indicator-abnormal-status.component';
import { FieldConditionComponent } from './widget/field-condition/field-condition.component';
import { TaskAbnormalStatisticsComponent } from './components/task-abnormal-statistics/task-abnormal-statistics.component';
import { TaskExecuteTimeComponent } from './components/task-execute-time/task-execute-time.component';
import { SimpleStatisticsComponent } from './views/simple-statistics/simple-statistics.component';
import { LogGridComponent } from './views/log-grid/log-grid.component';
import { ScanAuditOrIndicatorWhenIndicatorStatusComponent } from './widget/automation/parts/scan-audit-or-indicator-when-indicator-status/scan-audit-or-indicator-when-indicator-status.component';
import { GtjaGMOperationPlantCreateTaskComponent } from './widget/automation/parts/gtja-gmoperation-plant-create-task/gtja-gmoperation-plant-create-task.component';
import {NzListModule} from 'ng-zorro-antd/list';
import { TimingStatusGroupMovingComponent } from './widget/automation/parts/timing-status-group-moving/timing-status-group-moving.component';

const zorro = [
  NzGridModule,
  NzDividerModule,
  NzIconModule,
  NzButtonModule,
  NzInputNumberModule,
  NzAutocompleteModule,
  NzCascaderModule,
  NzCheckboxModule,
  NzDatePickerModule,
  NzFormModule,
  NzInputModule,
  NzRadioModule,
  NzSelectModule,
  NzSliderModule,
  NzSwitchModule,
  NzTimePickerModule,
  NzTransferModule,
  NzTreeSelectModule,
  NzUploadModule,
  NzAvatarModule,
  NzBadgeModule,
  NzCalendarModule,
  NzCardModule,
  NzPopoverModule,
  NzStatisticModule,
  NzTableModule,
  NzTabsModule,
  NzTagModule,
  NzToolTipModule,
  NzTreeModule,
  NzAlertModule,
  NzDrawerModule,
  NzMessageModule,
  NzModalModule,
  NzPopconfirmModule,
  NzProgressModule,
  NzSpinModule,
  NzLayoutModule,
  NzAffixModule,
  NzDropDownModule,
  NzStepsModule,
  NzBreadCrumbModule,
  NzCollapseModule,
  NzPaginationModule,
  NzSkeletonModule,
  NzEmptyModule,
  NzListModule
];
// 定义的路由
const routes: Routes = [
  { path: 'index', component: LayoutComponent, data: {title: '任务面板'}},
  { path: 'panel', component: TaskPanelComponent, data: {title: '任务面板'}},
  { path: 'archive', component: ArchiveComponent, data: {title: '归档面板'}},
  { path: 'task-statistics', component: SimpleStatisticsComponent, data: {title: '任务统计'}}
];
@NgModule({
  declarations: [
    AbstractPartComponent,
    TaskPanelComponent,
    ConversationComponent,
    FilterComponent,
    TableComponent,
    CalendarComponent,
    MultiplePersonComponent,
    StatusComponent,
    DropdownComponent,
    ArchiveComponent,
    LayoutComponent,
    PulseCardComponent,
    IntegrationComponent,
    AutomationComponent,
    CommonStatusComponent,
    CommonDateComponent,
    CommonColumnComponent,
    CustomSpecialConditionComponent,
    PulseIntegrationComponent,
    SchedulerComponent,
    CommonSchedulerComponent,
    LongTimeAgoPipe,
    TransforStringJsonPipe,
    WhenComponent,
    BoardMemberComponent,
    TimerComponent,
    CommonTimerComponent,
    CommonSendEmailComponent,
    CommonTimerEmailComponent,
    TDayComponent,
    ConditionComponent,
    FieldConditionComponent,
    CommonStatusArchiveComponent,
    DateTimeComponent,
    SelectComponent,
    NotificationComponent,
    CommonStatusTimerEmailComponent,
    CommonTimerNotificationComponent,
    InfoboxComponent,
    ArchivedBoardComponent,
    UserComponent,
    PulseCreatedSendNotificationComponent,
    FileComponent,
    LinkComponent,
    SearchPipePipe,
    CommonTextChangeComponent,
    CommonProductChangeUpdateComponent,
    CommonStatusNotifyComponent,
    CommonStatusChangeUserComponent,
    NewCalendarComponent,
    TimeIntervalComponent,
    MemberComponent,
    RelationDataComponent,
    StatusConditionCreateComponent,
    StatusGroupMovingComponent,
    StatusGroupMovingNotifyComponent,
    VoteComponent,
    DateSliderComponent,
    LastUpdatedComponent,
    StatusTimerArchiveComponent,
    WorkRelationComponent,
    CommonWorkflowCreateTaskComponent,
    CommonWorkflowUpdateTaskComponent,
    CommonWorkflowDeleteTaskComponent,
    CommonAuditCreateTaskComponent,
    CommonAuditDeleteTaskComponent,
    CommonAuditUpdateTaskComponent,
    CommonWorkflowDeleteTaskComponent,
    DateSliderComponent,
    NewTableComponent,
    TableColumnNameComponent,
    TableColumnTextComponent,
    TableColumnDateComponent,
    TableColumnStatusComponent,
    TableColumnProgressComponent,
    TablePulseNameComponent,
    TablePulseDateComponent,
    TablePulseProgressComponent,
    TablePulseStatusComponent,
    TablePulseTextComponent,
    TablePulseMultiplePersonComponent,
    TableColumnMultiplePersonComponent,
    TableColumnSelectComponent,
    TablePulseSelectComponent,
    TableColumnDateTimeComponent,
    TableColumnTimeIntervalComponent,
    // TablePulseDataTimeComponent,
    TablePulseTimeIntervalComponent,
    TableColumnButtonComponent,
    TableColumnDropdownComponent,
    TablePulseButtonComponent,
    TablePulseDropdownComponent,
    TableColumnCreateTimeComponent,
    TablePulseCreateTimeComponent,
    TablePulseAbstractComponent,
    TableViewAbstractComponent,
    TreeTableComponent,
    MultipleLevelPersonComponent,
    TaskStatusComponent,
    TaskHandleComponent,
    TaskProgressComponent,
    HandlerComponent,
    TaskButtonComponent,
    CommonTaskStatusArchiveComponent,
    CommonSupervisoryUpdateTaskComponent,
    CommonLogTaskArchiveComponent,
    CheckListComponent,
    RatioSuperisoryComponent,
    WarnedComponent,
    SupervisorySchedulerComponent,
    TaskFilterComponent,
    TaskManagementComponent,
    SetSchedulerComponent,
    IntegrateSupervisoryCreatComponent,
    IntegrateSupervisoryTaskRuleCreatComponent,
    CreateTaskByIndicatorAbnormalStatusComponent,
    FieldConditionComponent,
    TaskAbnormalStatisticsComponent,
    TaskExecuteTimeComponent,
    SimpleStatisticsComponent,
    LogGridComponent,
    ScanAuditOrIndicatorWhenIndicatorStatusComponent,
    GtjaGMOperationPlantCreateTaskComponent,
    TimingStatusGroupMovingComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...zorro,
    DragDropModule,
    ScrollingModule,
    ResizableModule,
    NzResizableModule,
    NgxPermissionsModule.forRoot(),
    RouterModule.forChild(routes),
    QuillModule.forRoot(),
    NgFondaModule,
    BpmnViewModule
  ],
  exports: [
    TaskPanelComponent,
    ConversationComponent,
    FilterComponent,
    TableComponent,
    NewTableComponent,
    CalendarComponent,
    NewCalendarComponent,
    MultiplePersonComponent,
    StatusComponent,
    DropdownComponent,
    ArchiveComponent,
    LayoutComponent,
    PulseCardComponent,
    AutomationComponent,
    CommonStatusComponent,
    CommonStatusArchiveComponent,
    CommonTaskStatusArchiveComponent,
    CommonDateComponent,
    CommonColumnComponent,
    CustomSpecialConditionComponent,
    SchedulerComponent,
    WhenComponent,
    CommonSchedulerComponent,
    BoardMemberComponent,
    MemberComponent,
    TimerComponent,
    CommonTimerComponent,
    CommonSendEmailComponent,
    CommonTimerEmailComponent,
    CommonStatusTimerEmailComponent,
    TDayComponent,
    DateTimeComponent,
    TimeIntervalComponent,
    SelectComponent,
    NotificationComponent,
    CommonTimerNotificationComponent,
    PulseCreatedSendNotificationComponent,
    InfoboxComponent,
    DateSliderComponent,
    LastUpdatedComponent,
    UserComponent,
    CheckListComponent,
    RatioSuperisoryComponent,
    WarnedComponent,
    SupervisorySchedulerComponent,
    IntegrateSupervisoryCreatComponent,
    IntegrateSupervisoryTaskRuleCreatComponent,
    CreateTaskByIndicatorAbnormalStatusComponent,
    SimpleStatisticsComponent,
    LogGridComponent
  ],
  entryComponents: [
    CommonStatusComponent,
    CommonStatusArchiveComponent,
    CommonTaskStatusArchiveComponent,
    CommonTextChangeComponent,
    CommonDateComponent,
    CommonColumnComponent,
    CustomSpecialConditionComponent,
    CommonSchedulerComponent,
    CommonTimerComponent,
    CommonSendEmailComponent,
    CommonTimerEmailComponent,
    CommonStatusTimerEmailComponent,
    PulseCreatedSendNotificationComponent,
    TDayComponent,
    CommonTimerNotificationComponent,
    CommonStatusNotifyComponent,
    CommonProductChangeUpdateComponent,
    CommonSupervisoryUpdateTaskComponent,
    CommonLogTaskArchiveComponent,
    CheckListComponent,
    RatioSuperisoryComponent,
    WarnedComponent,
    SupervisorySchedulerComponent,
    IntegrateSupervisoryCreatComponent,
    IntegrateSupervisoryTaskRuleCreatComponent,
    CreateTaskByIndicatorAbnormalStatusComponent
  ],
  providers: [
    { provide: InjectableRxStompConfig, useValue: myRxStompConfig }, // websocket服务
    { provide: RxStompService, useFactory: rxStompServiceFactory, deps: [InjectableRxStompConfig]},
  ]
})
export class TaskCenterModule { }
